export { getMarketingClickIds } from './marketing-click-ids'
export type { MarketingClickIdParam, MarketingClickIds } from './types'
export {
  MARKETING_CLICK_ID_COOKIE_FALLBACK,
  MARKETING_CLICK_ID_PARAMS,
  MARKETING_CLICK_IDS_EXPIRY_DAYS,
  STORAGE_KEY_MARKETING_CLICK_IDS,
} from './types'
